import type React from 'react'

type Props = {
  size?: number
}

const IconLinkArrow: React.FC<Props> = ({ size = 12 }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.3239 1.48145V9.45509C11.3239 9.92022 10.9585 10.2525 10.5266 10.2525C10.0614 10.2525 9.72919 9.92022 9.72919 9.45509V3.40841L2.05456 11.083C1.88844 11.2492 1.6891 11.3156 1.48976 11.3156C1.25719 11.3156 1.05785 11.2492 0.924958 11.083C0.592722 10.784 0.592722 10.2857 0.924958 9.98666L8.59959 2.27881H2.55291C2.08778 2.27881 1.75555 1.94658 1.75555 1.48145C1.75555 1.04954 2.08778 0.684082 2.55291 0.684082H10.5266C10.9585 0.684082 11.3239 1.04954 11.3239 1.48145Z"
        fill="currentColor"
      />
    </svg>
  )
}

export default IconLinkArrow
